import { cn } from "@/lib/utils";
import React from "react";

export interface BlockContainerProps {
  children: React.ReactNode;
  className?: string;
  fullWidth?: boolean; // For blocks that need to break out of the container
  noPadding?: boolean; // For blocks that want max-width but no horizontal padding
}

/**
 * BlockContainer provides consistent max-width and padding for content blocks.
 *
 * Tailwind's max-w-7xl = 1280px (80rem)
 * Tailwind's max-w-screen-xl = 1280px
 * Tailwind's max-w-screen-2xl = 1536px (96rem)
 *
 * Using max-w-screen-2xl for wider content that matches navigation width
 */
export const BlockContainer: React.FC<BlockContainerProps> = ({
  children,
  className,
  fullWidth = false,
  noPadding = false,
}) => {
  if (fullWidth) {
    return <>{children}</>;
  }

  return (
    <div
      className={cn(
        "mx-auto w-full",
        "max-w-[85rem]", // 1360px - wider content area
        !noPadding && "px-4 sm:px-6 lg:px-8", // Default horizontal padding
        className
      )}
    >
      {children}
    </div>
  );
};
